module.exports = "https://coursera_assets.s3.amazonaws.com/images/a2ab33760e6f92c9532aefd3aec60a85.png";